import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { hideVisually } from 'polished';

const HiddenRadio = styled.input.attrs({ type: 'radio' })`
  /* Hide checkbox visually but remain accessible to screen readers. */
  ${hideVisually()}
`;

const Label = styled.label`
  cursor: pointer;
  display: inline-flex;
  align-items: center;

  > span {
    margin-left: 0.33rem;
    font-size: 1rem;
  }
`;

const Icon = styled.svg`
  display: block;
`;

const StyledRadio = styled.div`
  display: inline-block;
  position: relative;
  width: 16px;
  height: 16px;
  border: 1px solid ${({ theme }) => theme.palette.primary[0]};
  background: ${({ theme, checked }) => (checked ? theme.palette.primary[0] : 'white')};
  border-radius: 100%;
  transition: all ${({ theme }) => theme.anim.dur};

  &::after {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    content: "";
    border-radius: 100%;
    transition: all ${({ theme }) => theme.anim.dur};
  }

  ${Label}:hover &::after {
    opacity: 1;
  }

  ${Icon} {
    visibility: ${(props) => (props.checked ? 'visible' : 'hidden')}
  }
`;

const RadioContainer = styled.div`
  display: inline-block;
  height: 18px;
`;

const Radio = ({
  className, checked, label, ...props
}) => (
  <Label>
    <RadioContainer className={className}>
      <HiddenRadio checked={checked} {...props} />
      <StyledRadio checked={checked}>
        <Icon width="16" height="16">
          <circle cx="7" cy="7" r="2" fill="white" />
        </Icon>
      </StyledRadio>
    </RadioContainer>
    <span>{label}</span>
  </Label>
);

Radio.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

Radio.defaultProps = {
  className: '',
  label: '',
};

export default Radio;
